/**
 *
 *
 */

/* 메뉴유형 */
export const MENU_TYPE = {
  GENERAL: {
    title: '일반',
    color: 'blue',
  },
  MD: {
    title: 'MD상품',
    color: 'orange',
  },
  DESSERT: {
    title: '디저트',
    color: 'purple',
  },
  ETC: {
    title: '기타',
    color: 'default',
  },
  ALC: {
    title: '주류',
    color: 'magenta',
  },
};
